import ArmsRum from '@arms/rum-browser';

ArmsRum.init({
  pid: 'dm6g54nfsb@5804e3ea1abf84b',
  endpoint: 'https://dm6g54nfsb-default-cn.rum.aliyuncs.com',
  // 设置环境信息，参考值：'prod' | 'gray' | 'pre' | 'daily' | 'local'
  env: import.meta.env.VITE_ENV === 'production' ? 'prod' : 'daily', 
  // 设置路由模式， 参考值：'history' | 'hash'
  spaMode: 'history',
  collectors: {
    // 页面性能指标监听开关，默认开启
    perf: true,
    // WebVitals指标监听开关，默认开启
    webVitals: true,
    // Ajax监听开关，默认开启
    api: true,
    // 静态资源开关，默认开启
    staticResource: true,
    // JS错误监听开关，默认开启
    jsError: true,
    // 控制台错误监听开关，默认开启
    consoleError: true,
    // 用户行为监听开关，默认开启
    action: true,
  },
  // 链路追踪配置开关，默认关闭
  tracing: false,
});

export default ArmsRum;

type CustomTrackType = {
  type: string, // 类型
  name: string,  // 名称
  group?: string, // 分组
  value?: any, // 值
  properties?: Record<string, any> // 属性
}

// 自定义事件
const customTrack = ({
  type,
  name,
  group,
  value,
  properties,
}: CustomTrackType) => {
  ArmsRum.sendCustom({
    type,
    name,
    group,
    value,
    properties,
  })
}

// 矢量服务错误监控
export const customerTrackIncomeServe = (
  apiName: string,
  requestData: Record<string, any>,
  responseData: Record<string, any>,
  responseCode: string,
) => {
  customTrack({
    type: '接口请求', 
    group: '矢量接口错误', 
    name: apiName, 
    value: null, 
    properties: {
      responseCode,
      requestData,
      responseData,
    },
  })
}


// 商城服务错误监控
export const customerTrackMallServe = (
  apiName: string,
  requestData: Record<string, any>,
  responseData: Record<string, any>,
  responseCode: string,
) => {
  customTrack({
    type: '接口请求', 
    group: '商城接口错误', 
    name: apiName, 
    value: null, 
    properties: {
      responseCode,
      requestData,
      responseData,
    },
  })
}